.backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.dropdown {
  position: fixed;
  z-index: 10000;
  background: var(--sbb-color-white);
  border: 1px solid var(--sbb-color-iron);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  max-width: 340px;
  font-family: var(--sbb-font-roman);
  font-size: 15px;
}

.dropdownHeader {
  padding: 10px 14px 8px;
  font-weight: 600;
  border-bottom: 1px solid var(--sbb-color-milk);
  white-space: nowrap;
}

.dropdownBody {
  padding: 10px 14px;
  max-height: 320px;
  overflow-y: auto;
}

.searchWrapper {
  margin-bottom: 12px;
}

.dropdownFooter {
  padding: 8px 14px;
  border-top: 1px solid var(--sbb-color-milk);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
